import { render } from "./createDoc.vue?vue&type=template&id=3550c215"
import script from "./createDoc.vue?vue&type=script&lang=js"
export * from "./createDoc.vue?vue&type=script&lang=js"

import "./createDoc.vue?vue&type=style&index=0&id=3550c215&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__